<h1 mat-dialog-title>Create New {{ data.objectType | titlecase }}</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="fill" class="full-width d-sm-flex flex-column">
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput required/>
            @if (form.get('name')?.hasError('required')) {
                <mat-error>
                    Name is required
                </mat-error>
            }
        </mat-form-field>
    </form>
    <small>When you create the {{ data.objectType }}, it may take 5-10 seconds for the object to be stored and
        available. We will redirect you to the created {{ data.objectType }} when its ready.</small>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">
        Create
    </button>
</div>
